




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class AdminListIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const { params: { role }, query } = this.$route;
    const queryString = new URLSearchParams({ ...query, serviceType: 'PRO' }).toString();
    const menuSegment = role ? 'role' : 'admin';
    const roleSegment = role ? `/${role}` : '';
    this.remoteSrc =
      process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/management/${menuSegment}${roleSegment}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
